import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Polygon from 'routes/decision-trees/components/Polygon';

import styles from './styles.module.scss';

export default function Decisions(props) {
  const {
    directionColumn,
    firstCaseContent,
    secondCaseContent,
    firstCaseBackground,
    secondCaseBackground,
    firstCaseHandler,
    secondCaseHandler
  } = props;

  const classes = classNames({
    [styles.decisions]: true,
    [styles['directionColumn']]: directionColumn
  });

  return (
    <div className={classes}>
      <div className={styles.firstCase}>
        <Polygon background={firstCaseBackground} onClick={firstCaseHandler}>
          {firstCaseContent}
        </Polygon>
      </div>
      <div className={styles.secondCase}>
        <Polygon background={secondCaseBackground} onClick={secondCaseHandler}>
          {secondCaseContent}
        </Polygon>
      </div>
    </div>
  );
}

Decisions.propTypes = {
  directionColumn: PropTypes.bool,
  firstCaseContent: PropTypes.node,
  secondCaseContent: PropTypes.node,
  firstCaseBackground: PropTypes.string,
  secondCaseBackground: PropTypes.string,
  firstCaseHandler: PropTypes.func,
  secondCaseHandler: PropTypes.func
};
